export default function PrisModeller() {
  return (
    <section className="mt-[-60px] md:mt-[-245px]">
      <div className="py-8 md:px-4 mx-auto container md:max-w-screen-lg lg:py-16 lg:px-6">
        <div className="space-y-16 lg:grid lg:grid-cols-2 gap-2 lg:space-y-0">
          <div className="flex flex-col md:w-[45rem] p-10 md:py-16 md:px-20 mx-auto text-left text-gray-900 bg-white rounded-3xl border border-gray-100 drop-shadow-pris">
            <h3 className="mb-2 text-left text-7xl text-doctio-dark font-bold">
              Doctio Basic
            </h3>
            <p className="text-doctio-dark">
              For dig der gerne vil prøve Doctio af eller sjældent bruger fraser
              i dit arbejde.
            </p>
            <div className="flex flex-col py-4 rounded-2xl items-center justify-center bg-doctio-dark-blue my-4">
              <span className="mr-2 text-white text-d4xl font-bold">
                Gratis
              </span>
              <span className="text-white opacity-90">
                Kreditkort ikke nødvendigt
              </span>
            </div>
            <ul className="mb-8 space-y-4 mt-4 px-6 text-left">
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Standardkatalog med{" "}
                  <span className="font-bold">tekstfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <p className="text-doctio-green m-0 font-bold">Få</p>
                <span className="text-doctio-dark font-bold">
                  Dynamiske klikfraser
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  className="invisible"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-black/25">Reklamefri</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Opret egne <span className="font-bold">klikfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Rediger eksisterende{" "}
                  <span className="font-bold">klikfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Personligt bibliotek af{" "}
                  <span className="font-bold">tekstfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">Noter</span>
              </li>

              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Cloudbaseret web applikation
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 invisible w-5 h-5 text-green-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="text-black/25">Del fraser mellem brugere</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 invisible w-5 h-5 text-green-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="text-black/25">Adminstrationsmodul</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 invisible w-5 h-5 text-green-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="text-black/25">
                  Løbende ajourføring af fraser
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 invisible w-5 h-5 text-green-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="text-black/25">
                  DoctioAssist med autosuggestion
                </span>
              </li>
            </ul>
            <a
              href="/signup"
              className="text-white hover:shadow-md text-dlg bg-doctio-dark-blue hover:bg-white hover:text-doctio-dark transition-colors duration-300 ease-in-out focus:ring-4 focus:ring-primary-200 font-bold mt-6 rounded-full px-5 py-5 text-center"
            >
              Opret gratis konto
            </a>
          </div>
          <div className="flex flex-col md:w-[45rem] p-10 md:py-16 md:px-20 mx-auto text-left text-gray-900 bg-white rounded-3xl border border-gray-100 drop-shadow-pris">
            <h3 className="mb-2 text-left text-7xl text-doctio-green font-bold">
              Doctio Pro
            </h3>
            <p className="text-doctio-dark">
              For dig der vil spare tid og have et klinisk understøttende
              beslutningsværktøj.
            </p>
            <div className="flex flex-col py-4 rounded-2xl items-center justify-center bg-doctio-green my-4">
              <span className="mr-2 text-white text-d4xl font-bold">179,-</span>
              <span className="text-white opacity-90">
                pr. måned inkl. moms
              </span>
            </div>
            <ul className="mb-8 space-y-4 mt-4 px-6 text-left">
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Standardkatalog med{" "}
                  <span className="font-bold">klikfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark font-bold">
                  Dynamiske klikfraser
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">Reklamefri</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Opret egne <span className="font-bold">klikfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Rediger eksisterende{" "}
                  <span className="font-bold">tekstfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Personligt bibliotek af{" "}
                  <span className="font-bold">tekstfraser</span>
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  {" "}
                  Noter, medier og dokumentsamling
                </span>
              </li>

              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Cloudbaseret web applikation
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Del fraser mellem brugere
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">Adminstrationsmodul</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  Løbende ajourføring af fraser
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  fill="#1f7672"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 26"
                  width="18px"
                  height="18px"
                >
                  <path d="M 22.566406 4.730469 L 20.773438 3.511719 C 20.277344 3.175781 19.597656 3.304688 19.265625 3.796875 L 10.476563 16.757813 L 6.4375 12.71875 C 6.015625 12.296875 5.328125 12.296875 4.90625 12.71875 L 3.371094 14.253906 C 2.949219 14.675781 2.949219 15.363281 3.371094 15.789063 L 9.582031 22 C 9.929688 22.347656 10.476563 22.613281 10.96875 22.613281 C 11.460938 22.613281 11.957031 22.304688 12.277344 21.839844 L 22.855469 6.234375 C 23.191406 5.742188 23.0625 5.066406 22.566406 4.730469 Z" />
                </svg>
                <span className="text-doctio-dark">
                  DoctioAssist med autosuggestion
                </span>
              </li>
            </ul>
            <a
              href="/signup"
              className="text-white hover:shadow-md text-dlg bg-doctio-green hover:bg-white hover:text-doctio-green transition-colors duration-300 ease-in-out focus:ring-4 focus:ring-primary-200 font-bold mt-6 rounded-full px-5 py-5 text-center"
            >
              Prøv gratis i 14 dage
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
